<script>
import { RouteStopStatus, RouteStopStatusMap } from "@/constants/trip";

export default {
  name: "RouteStopStatusLabel",
  props: {
    stop: Object,
    isBadge: {
      type: Boolean,
      default: false,
    },
    isCancelled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    status() {
      const statuses = RouteStopStatusMap.filter((s) => s.id === this.stop.status);
      if (statuses.length === 1) {
        return statuses[0].name;
      } else if (statuses.length > 1) {
        return statuses.find((s) => s.type === this.stop?.type)?.name;
      }
      return null;
    },
    badgeColor() {
      if (this.isCancelled) {
        return "bg-transparent";
      }

      switch (this.stop.status) {
        case RouteStopStatus.inRoute:
          return "bg-amber-lighten-2";
        case RouteStopStatus.completed:
          return "bg-green-lighten-2";
        case RouteStopStatus.waitingForGoodToGo:
          return "bg-cyan-accent-2";
        case RouteStopStatus.notStarted:
          return "bg-grey-lighten-2";
        case RouteStopStatus.waitingForLoading:
          return "bg-blue-lighten-2";
        case RouteStopStatus.waitingForVerification:
          return "bg-blue-lighten-2";
        default:
          return "";
      }
    },
  },
};
</script>

<template>
  <div v-if="isBadge" class="font-size-12 font-weight-500 text-grey-darken-1" v-bind="$props">
    {{ status }}
  </div>
  <div
    v-else
    :class="badgeColor"
    class="font-size-12 text-grey-darken-3 d-inline-block status rounded-lg"
    v-bind="$props"
  >
    {{ status }}
  </div>
</template>

<style lang="scss" scoped>
.status {
  padding: 2px 8px;
}
</style>
